import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../report-page.component.css';
import ButtonIcon from "../../../button";
import { ORFSelect, ORFDropdownCheckbox, ORFButton } from '../../../common/forms/order-request-form.component';


export class OrderVolumeFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideFilter: false,
            selectedRegions: [],
            selectedAllRegions: false,
            regions: [
                {
                    "Key": "APAC",
                    "Value": "APAC"
                },
                {
                    "Key": "NE",
                    "Value": "NE"
                },
                {
                    "Key": "AFRIKA",
                    "Value": "AFRIKA"
                },
                {
                    "Key": "LAT",
                    "Value": "LAT"
                },
                {
                    "Key": "ME",
                    "Value": "ME"
                },
                {
                    "Key": "SEE",
                    "Value": "SEE"
                },
                {
                    "Key": "WE",
                    "Value": "WE"
                },
                {
                    "Key": "NAM",
                    "Value": "NAM"
                },
                {
                    "Key": "India",
                    "Value": "India"
                },
                {
                    "Key": "China",
                    "Value": "China"
                }
            ],
            years: [
                {
                    "Key": "2019",
                    "Value": "2019"
                },
                {
                    "Key": "2020",
                    "Value": "2020"
                },
                {
                    "Key": "2021",
                    "Value": "2021"
                }
            ],
            weeks: [
                {
                    "Key": "1",
                    "Value": "1"
                },
                {
                    "Key": "2",
                    "Value": "2"
                },
                {
                    "Key": "3",
                    "Value": "3"
                }
            ]
        }
    }

    onCheckDropdown = (e) => {
        const { selectedRegions, selectedAllRegions, regions } = this.state;
        const target = e.target;
        const value = target.value;
        let newSelectedValues = [];

        if ((this.getAllValues(regions).find(x => x === value) == undefined)) {
            newSelectedValues = selectedAllRegions ? [] : this.getAllValues(regions);
        } else {
            newSelectedValues = this.updateSelectedValues(value, selectedRegions);
        }

        this.setState({
            selectedAllRegions: newSelectedValues.length == regions.length,
            selectedRegions: newSelectedValues
        });
    }

    showHideFilter = (e,v) => {
        this.setState({
            hideFilter: !v,
        });
    }


    getKeyByValue = (object, value) => {
        return object.find(o => o.Value === value).Key;
    }
    getAllValues = (objects) => {
        var newList = [];
        objects.forEach(function (obj) {
            newList.push(obj.Value);
        })
        return newList;
    }

    getAllKeys = (objects) => {
        var newList = [];
        objects.forEach(function (obj) {
            newList.push(obj.Key);
        })
        return newList;
    }

    updateSelectedValues = (v, options) => {

        var newFilter = [...options];
        if (options.some((value) => value === v)) {
            newFilter = newFilter.filter((val) => val !== v);
        } else {
            newFilter.push(v);
        }

        return newFilter
    }

    render() {
        const { regions, selectedRegions, selectedAllRegions, years, weeks, hideFilter } = this.state;

        return (
            <div className="component-container legend-center second-col-container">
                <div className="order-filter-header-container">
                    <div>
                        <h2 className="report-header-label">
                            Order Volume
                        </h2>
                    </div>
                    <div className="order-filter-header-right">
                        <div  className="order-filter-header-right-content">
                           <h1 className="order-filter-week-label"> Week 20 </h1>
                        </div>
                        <div className="order-filter-header-right-content">
                            <ButtonIcon onClick={() => alert("click")} iconLeft="file-pdf" iconSize="14px" customClassName="pdf-button" labelName="Customize Report" />
                        </div>
                        <div className="order-filter-header-right-content">
                            <ButtonIcon onClick={() => alert("click")} iconLeft="file-pdf" iconSize="14px" customClassName="pdf-button" labelName="Export File" />
                        </div>
                        <div className="order-filter-header-right-content">
                            <span className="order-filter-header-link" onClick={e => this.showHideFilter(e, hideFilter)}>{hideFilter ? "Show" : "Hide"} Filter</span>
                        </div>                    
                    </div>
                </div>
                <div hidden={hideFilter} className="order-filter-list-container">
                    <div className="order-filter-list-item-container">
                        <ORFDropdownCheckbox
                            className="form-control"
                            label={"Region"}
                            options={regions}
                            placeholder={"Select Region"}
                            fieldName='model.region'
                            action={this.onCheckDropdown}
                            selectedValues={selectedRegions}
                            isSelectAll={selectedAllRegions}
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                        <ORFSelect
                            className="form-control"
                            label={"Year"}
                            options={years}
                            placeholder={""}
                            fieldName='model.year'
                        />
                    </div>                 
                    <div className="order-filter-list-item-container">
                        <ORFSelect
                            className="form-control"
                            label={"Week From"}
                            options={weeks}
                            placeholder={""}
                            fieldName='model.region'
                        />
                    </div>
                    <div className="order-filter-list-item-container">
                        <ORFSelect
                            className="form-control"
                            label={"Week To"}
                            options={weeks}
                            placeholder={""}
                            fieldName='model.region'
                        />
                    </div>
                    <div className="order-filter-list-item-button-container">
                        <ORFButton
                            label={"Reset"}
                            variant={"outline-secondary"}
                        />
                    </div>
                    <div className="order-filter-list-item-button-container">
                        <ORFButton
                            label={"Apply Filter"}
                            variant={"primary"}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
